/** Frontend gate for experimental Base ecosystem UI. Default false.

Build-time: REACT_APP_BASE_ECOSYSTEM_ENABLED (CRA bake-in).
Runtime: /api/config base_ecosystem.enabled (backend authoritative).

Either may enable the surface; both false → hidden. Backend still 404s if disabled.
*/

export function baseEcosystemEnabledFromEnv() {
  const raw = (process.env.REACT_APP_BASE_ECOSYSTEM_ENABLED || "").trim().toLowerCase();
  return raw === "1" || raw === "true" || raw === "yes" || raw === "on";
}

/** @deprecated prefer isBaseEcosystemEnabled(config) for UI gates */
export const BASE_ECOSYSTEM_ENABLED = baseEcosystemEnabledFromEnv();

export function isBaseEcosystemEnabled(config) {
  if (baseEcosystemEnabledFromEnv()) return true;
  return Boolean(config?.base_ecosystem?.enabled);
}
